module.exports = __webpack_public_path__ + "static/img/products application_tunnel1.0a4ce3f0.jpg";